import React from 'react'
import { motion } from 'framer-motion'

function SvgIndustries(props) {
  return (
    <svg
      viewBox="0 0 2000 2000"
      width="400px"
      height="400px"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g>
        <path d="M0 1530.35h2000v4.66H0v-4.66z" fill="#3f3d56" />
        <path
          d="M1254.84 733.858s-89.71 70.485-44.86 86.504c44.86 16.019 73.69-57.67 73.69-57.67l-28.83-28.834z"
          fill="#fbc5c5"
        />
        <path
          d="M1258.04 708.227l-19.22 32.038s32.04 0 38.45 48.058l25.63-32.038-44.86-48.058z"
          fill="#cfcce0"
        />
        <path
          d="M1684.16 1438.71l3.2 96.11-38.45 22.43-16.01-9.61 3.2-108.93h48.06zM1456.68 1413.08l6.41 102.52-89.71 38.45 6.41-54.47s25.63-41.65 19.22-86.5h57.67z"
          fill="#fbc5c5"
        />
        <path
          d="M1594.45 640.946s51.26 134.562 60.87 217.862c9.61 83.301 25.63 304.362 25.63 304.362l32.04 285.15-89.71 12.81-38.44-288.34-86.51-285.147-19.22 285.147-16.02 259.51-83.3 3.2-6.41-269.12-35.24-342.814 19.22-163.397 237.09-19.223zM1642.51 1541.23s5.25-53.81 44.27-23.7l6.99-5.13 32.04 70.48s38.44 54.47-28.84 60.87c-67.28 6.41-60.87-60.87-60.87-60.87l-6.41-28.83 3.2-18.89 9.62 6.07zM1456.68 1477.15c16.06 9.19 25.88 26.36 25.63 44.86 0 32.04-3.2 35.24-3.2 35.24l-48.06 12.81s-32.04-3.2-51.26 16.02c-19.22 19.23-115.34 32.04-115.34 6.41s80.1-67.28 80.1-67.28 23.78-40.17 40.72-36.1c16.95 4.06 23.35 10.47 23.35 13.67 0 3.21-9.61 25.63-9.61 25.63s54.47-12.81 57.67-51.26z"
          fill="#2f2e41"
        />
        <path
          d="M1370.18 166.775c0-44.236 35.86-80.097 80.09-80.097 44.24 0 80.1 35.861 80.1 80.097s-35.86 80.096-80.1 80.096c-44.23 0-80.09-35.86-80.09-80.096z"
          fill="#fbc5c5"
        />
        <path
          d="M1509.55 187.6l35.24 80.096-106.94 137.766s-2.61-55.635-4.64-104.014c0 0 4.83-11.969 4.64-15.256-1.63-28.957-5.09-47.87-12.05-57.14-19.22-25.631 83.75-41.452 83.75-41.452z"
          fill="#fbc5c5"
        />
        <path
          d="M1515.95 301.448c20.03-22.426 14.42-65.294 14.42-65.294l25.89 17.247 49.4 421.185-259.51 6.408 35.24-291.551 32.04-83.3 24.42-20.099s-4.31 26.128 14.03 36.118c24.03 13.095 44.05 1.713 64.07-20.714z"
          fill="#d6d3e6"
        />
        <path
          d="M1538.38 533.617l17.88-280.216 131.1 28.713-27.23 376.269s89.73 232.598 34.59 245.414c-55.14 12.815-153.17 9.611-153.17 9.611l-3.17-379.791zM1382.99 496.772l33.99-195.324-75.64 51.151 19.23 140.969-16.02 96.116s-60.88 265.92-41.65 275.532c19.22 9.612 41.65 0 41.65 0l38.44-269.124v-99.32z"
          fill="#3f3d56"
        />
        <path
          d="M1363.77 346.191l-22.43 6.408-9.61 128.154-16.02 112.135-76.89 137.766s38.45-25.631 54.47 48.058l84.68-147.433-14.2-285.088z"
          fill="#3f3d56"
        />
        <path
          d="M1613.67 708.227s-89.71 70.485-44.85 86.504c44.85 16.019 73.69-57.669 73.69-57.669l-28.84-28.835z"
          fill="#fbc5c5"
        />
        <path
          d="M1668.14 743.47l-28.84 35.242-38.44-67.282 16.01-28.834 51.27 60.874z"
          fill="#cfcce0"
        />
        <path
          d="M1661.73 294.929l25.63-12.815s19.22 25.631 22.43 48.058c3.2 22.427 19.22 51.261 19.22 67.281 0 16.019 44.85 166.6 44.85 166.6l-102.52 208.251s-22.43-76.892-70.48-83.3l80.09-112.135-44.85-80.097 25.63-201.843z"
          fill="#3f3d56"
        />
        <path
          d="M1517.33 90.46l15.1-6.047s-31.58-34.769-75.52-31.745l12.36-13.606s-30.21-12.093-57.67 19.652c-14.44 16.688-31.14 36.304-41.55 58.401h-16.18l6.75 14.865-23.63 14.865 24.26-2.67a82.865 82.865 0 00-.66 24.656 31.913 31.913 0 0011.68 20.87s18.73-38.773 18.73-44.82v15.117s15.11-13.605 15.11-22.676l8.24 10.582 4.11-16.628 50.81 16.628-8.24-13.605 31.58 4.535-12.36-16.629s35.7 19.652 37.08 36.281c1.37 16.629 11.82 32.385 11.82 32.385s28-77.736-11.82-100.41z"
          fill="#2f2e41"
        />
        <path
          d="M1506.98 153.959c0-6.193 4.02-11.213 8.97-11.213 4.96 0 8.97 5.02 8.97 11.213s-4.01 11.214-8.97 11.214c-4.95 0-8.97-5.021-8.97-11.214z"
          fill="#ffb8b8"
        />
      </g>
      <motion.g
        animate={{ opacity: [0, 1] }}
        transition={{ duration: 1, delay: 3 }}
      >
        <g>
          <g fill="#3f3d56">
            <path d="M1246.04 501.101h-127.65v-127.65h86.62v3.039h-83.58v121.573H1243v-60.787h3.04v63.825zM1246.04 862.773h-127.65v-127.65h86.62v3.041h-83.58v121.57H1243v-60.786h3.04v63.825zM1246.04 1222.93h-127.65v-127.65h86.62v3.04h-83.58v121.57H1243v-60.79h3.04v63.83z" />
          </g>
          <motion.g
            animate={{ scale: [1, 1.2, 1] }}
            transition={{ duration: 1.5, loop: Infinity }}
          >
            <path
              d="M1181.56 1189.63c-2.95-8.71-39.95-38.32-17.28-43.29l18.59 24.78 85.46-85.46 8.6 8.6-95.37 95.37zM1181.56 829.478c-2.95-8.71-39.95-38.318-17.28-43.295l18.59 24.786 33.55-33.55 51.91-51.911 8.6 8.595-95.37 95.375zM1181.56 467.805c-2.95-8.71-39.95-38.318-17.28-43.294l18.59 24.786 85.46-85.462 8.6 8.596-95.37 95.374z"
              fill="#ffffff"
            />
          </motion.g>
        </g>
      </motion.g>
      <g>
        <motion.g
          animate={{ x: [-2000, 0] }}
          transition={{ duration: 1.5, delay: 1 }}
        >
          <path
            d="M370.73 1055.77H94.158v-77.505h144.366l132.206 77.505z"
            fill="#ffffff"
          />
          <path
            d="M93.398 1040.57v226.42H991.5v-226.42H93.398zM612.352 1229H151.904v-31.91h460.448V1229zm0-59.26H151.904v-31.91h460.448v31.91zm320.642-59.27h-781.09v-31.91h781.09v31.91z"
            fill="#3f3d56"
          />
        </motion.g>
        <motion.g
          animate={{ x: [-2000, 0] }}
          transition={{ duration: 1.5, delay: 0.5 }}
        >
          <path
            d="M370.73 697.133H94.158v-77.5h144.366l132.206 77.5z"
            fill="#ffffff"
          />
          <path
            d="M93.398 686.496v226.425H991.5V686.496H93.398zM443.673 874.93H151.904v-31.912h291.769v31.912zm489.322-59.266H151.904v-31.912h781.091v31.912zm0-59.265H151.904v-31.912h781.091v31.912z"
            fill="#3f3d56"
          />
        </motion.g>
        <motion.g animate={{ x: [-2000, 0] }} transition={{ duration: 1.5 }}>
          <g>
            <path
              d="M370.73 330.903H94.158v-77.502h144.366l132.206 77.502z"
              fill="#ffffff"
            />
            <path
              d="M93.398 324.824v226.425H991.5V324.824H93.398zm350.275 188.434H151.904v-31.912h291.769v31.912zm168.679-59.266H151.904V422.08h460.448v31.912zm320.643-59.265H151.904v-31.913h781.091v31.913z"
              fill="#3f3d56"
            />
          </g>
        </motion.g>
      </g>
    </svg>
  )
}

export default SvgIndustries
